import { LinkField, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';
import classnames from 'classnames';
import { LayoutPageSectionShell } from 'components/authorable/layout/LayoutPageSection/LayoutPageSection';
import Button from 'components/helpers/Button';
import { useCart } from 'components/helpers/Cart/CartHelper';
import useDictionary from 'lib/sitecore/use-dictionary';

const OrderSummary = () => {
  const { cart } = useCart();
  const dictionary = useDictionary();
  const { sitecoreContext } = useSitecoreContext();
  const cartLink = sitecoreContext?.cartLink as LinkField;
  // get the cartlink and update the text to 'Edit'
  const editLink = { ...cartLink?.value, text: 'Edit' };
  const cartLeftCol = (
    <>
      {cart?.map((item) => {
        return (
          <div key={item.id} className={classnames('mt-4', 'mb-2', 'md:pl-4')}>
            <div className={classnames('font-medium')}> {item.name}</div>
            <div
              className={classnames(
                'text-sm',
                'text-gray-darkGray',
                'flex',
                'justify-start',
                'flex-wrap'
              )}
            >
              {item.itemNumber !== '' && (
                <div className={classnames('pr-1')}>
                  {dictionary.ProductDetails_ItemNumber} {item.itemNumber},
                </div>
              )}
              <div>
                {dictionary.checkout_quantity_label} {item.quantity}
              </div>
            </div>
          </div>
        );
      })}
    </>
  );

  return (
    <div
      data-component="authorable/pages/cartpage"
      className={classnames(
        'text-solidBlack',
        'border-b-2',
        'border-l-0',
        'pb-4',
        'mb-8',
        'mt-8',
        'md:mt-10',
        'md:pb-0',
        'md:border-l-2',
        'border-plum',
        'md:border-b-0'
      )}
    >
      <LayoutPageSectionShell theme="theme-inherit" padding="tiny">
        <div
          className={classnames('md:pl-4', 'mt-2', 'flex', 'sm:justify-start', 'justify-between')}
        >
          <span className={classnames('text-lg', 'font-medium', 'md:text-2xl')}>
            {dictionary.checkout_order_summary_label}
          </span>
          {cartLink?.value?.href?.length && (
            <Button
              linkField={{ value: editLink }}
              variant="link"
              className={classnames('font-regular', 'pl-6')}
            />
          )}
        </div>
        {cartLeftCol}
      </LayoutPageSectionShell>
    </div>
  );
};

export default OrderSummary;
